module.exports = __webpack_public_path__ + "img/file-prescription.e6bae4ee.svg";